import { Typography } from "@material-ui/core"
import { STATUS_COLORS } from "../../../constants"
import { GroupedProjects } from "../../api/projects-dashboard"
import { useTranslations } from "./useTranslations"
import HorizontalBarChart from "../HorizontalBarChart"

const useTasksBasedCompletionStatistics = ({ totalProjects, groupedProjects }: TasksBasedCompletionStatisticsProps) => {
  const translations = useTranslations()

  const displayBarChart = totalProjects > 0

  const zeroColor = STATUS_COLORS.NOT_STARTED["1"]
  const upTo20Color = STATUS_COLORS.NOT_STARTED["0"]
  const upTo40Color = STATUS_COLORS.COMPLETED["0"]
  const upTo60Color = STATUS_COLORS.COMPLETED["1"]
  const upTo80Color = STATUS_COLORS.COMPLETED["2"]
  const upTo100Color = STATUS_COLORS.COMPLETED["3"]

  const labels = [
    {
      label: "0%",
      boxColor: zeroColor,
      hidePercentage: true,
      hideNumber: true,
    },
    {
      label: "1-20%",
      boxColor: upTo20Color,
      hidePercentage: true,
      hideNumber: true,
    },
    {
      label: "21-40%",
      boxColor: upTo40Color,
      hidePercentage: true,
      hideNumber: true,
    },
    {
      label: "41-60%",
      boxColor: upTo60Color,
      hidePercentage: true,
      hideNumber: true,
    },
    {
      label: "61-80%",
      boxColor: upTo80Color,
      hidePercentage: true,
      hideNumber: true,
    },
    {
      label: "81-100%",
      boxColor: upTo100Color,
      hidePercentage: true,
      hideNumber: true,
    },
  ]

  const data = [
    {
      value: groupedProjects["0"].numberOfProjects,
      percentage: groupedProjects["0"].percentageOfProjects.toFixed(1),
      tooltipContent: groupedProjects["0"].projects,
      backgroundColor: zeroColor,
    },
    {
      value: groupedProjects["20"].numberOfProjects,
      percentage: groupedProjects["20"].percentageOfProjects.toFixed(1),
      tooltipContent: groupedProjects["20"].projects,
      backgroundColor: upTo20Color,
    },
    {
      value: groupedProjects["40"].numberOfProjects,
      percentage: groupedProjects["40"].percentageOfProjects.toFixed(1),
      tooltipContent: groupedProjects["40"].projects,
      backgroundColor: upTo40Color,
    },
    {
      value: groupedProjects["60"].numberOfProjects,
      percentage: groupedProjects["60"].percentageOfProjects.toFixed(1),
      tooltipContent: groupedProjects["60"].projects,
      backgroundColor: upTo60Color,
    },
    {
      value: groupedProjects["80"].numberOfProjects,
      percentage: groupedProjects["80"].percentageOfProjects.toFixed(1),
      tooltipContent: groupedProjects["80"].projects,
      backgroundColor: upTo80Color,
    },
    {
      value: groupedProjects["100"].numberOfProjects,
      percentage: groupedProjects["100"].percentageOfProjects.toFixed(1),
      tooltipContent: groupedProjects["100"].projects,
      backgroundColor: upTo100Color,
    },
  ]

  return {
    displayBarChart,
    labels,
    data,
    translations,
  }
}

const CompletionStatistics = (props: TasksBasedCompletionStatisticsProps) => {
  const { displayBarChart, labels, data, translations } = useTasksBasedCompletionStatistics(props)

  if (!displayBarChart) {
    return (
      <Typography variant="body2" color="textSecondary">
        {translations.noData}
      </Typography>
    )
  }

  return <HorizontalBarChart labels={labels} data={data} />
}

export default CompletionStatistics
type TasksBasedCompletionStatisticsProps = {
  totalProjects: number
  groupedProjects: GroupedProjects
}
